import script from "./StatisticalQuantity.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatisticalQuantity.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__